<template>
	<div id="app">
		<transition :name="transitionName">
			<router-view class="body-wrap" />
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'app',
		data() {
			return {
				transitionName: 'slide-right'
			}
		},
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 16px;
		color: #333;
	}

	.slide-right-enter-active,
	.slide-right-leave-active,
	.slide-left-enter-active,
	.slide-left-leave-active {
		will-change: transform;
		transition: all .5s;
		position: absolute
	}


	.slide-right-enter {

		transform: translate3d(-100%, 0, 0)
	}

	.slide-right-leave-active {

		transform: translate3d(100%, 0, 0)
	}

	.slide-left-enter {

		transform: translate3d(100%, 0, 0)
	}

	.slide-left-leave-active {
		transform: ranslate3d(-100%, 0, 0)
	}

	/* Webkit 浏览器 */
	::-webkit-scrollbar {
		width: 10px;
	}

	::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	::-webkit-scrollbar-thumb {
		background-color: #4979ff;
		border-radius: 5px;
	}

	/* Firefox 浏览器 */
	scrollbar-color: #4979ff #f1f1f1;
	scrollbar-width: thin;
	html,
	body,
	p {
		padding: 0 !important;
		margin: 0 !important;
	}

	p {
		margin-bottom: 0.625rem;
	}

	/* 公共样式 */
	.flex {
		display: flex;
		flex-direction: row;
	}

	.wrap {
		flex-wrap: wrap;
	}

	.col-center {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.row-center {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.flex-sb {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.flex-sa {
		display: flex;
		flex-direction: row;
		justify-content: space-around;
	}

	.flex-center {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}

	.flex-cb {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
	.el-image-viewer__wrapper{
		z-index: 99999999999 !important;
	}
</style>